import { IStudentTermsDatasource } from './../datasources/student_terms_datasource';
import { StudentTerm } from './../builders/student_term_builder';
import { IQuery, IQueryMediator } from 'core-ts-types';

export class StudentTermsQuery implements IQuery {
  private _result: StudentTerm[];

  constructor(QueryMediator: IQueryMediator, private ngStudentTermsDatasource: IStudentTermsDatasource) {
    QueryMediator.registerQuery(this, ngStudentTermsDatasource);
  }

  run() {
    this._result = _.sortBy(_.values<StudentTerm>(this.ngStudentTermsDatasource.read()), 'term_start_date');
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-user-app').service('ngStudentTermsQuery', StudentTermsQuery);



// WEBPACK FOOTER //
// ./app/lib/user_app/queries/student_terms_query.ts